const CircleCheckIcon = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6719 11.125C20.6719 16.7441 16.0781 21.2969 10.5 21.2969C4.88086 21.2969 0.328125 16.7441 0.328125 11.125C0.328125 5.54688 4.88086 0.953125 10.5 0.953125C16.0781 0.953125 20.6719 5.54688 20.6719 11.125ZM9.31055 16.5391L16.8574 8.99219C17.1035 8.74609 17.1035 8.29492 16.8574 8.04883L15.9141 7.14648C15.668 6.85938 15.2578 6.85938 15.0117 7.14648L8.85938 13.2988L5.94727 10.4277C5.70117 10.1406 5.29102 10.1406 5.04492 10.4277L4.10156 11.3301C3.85547 11.5762 3.85547 12.0273 4.10156 12.2734L8.36719 16.5391C8.61328 16.7852 9.06445 16.7852 9.31055 16.5391Z"
        fill="#198754"
      />
    </svg>
  );
};
export default CircleCheckIcon;
